import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  providerNotificationSettingsService,
  ProviderNotificationSettingsRequestError,
} from '@/services/provider/notification-settings.service';
import type {
  ProviderNotificationSettings,
  UpdateProviderNotificationSettingsInput,
} from '@/types/provider-notification-settings';

export const providerNotificationSettingsKeys = {
  all: ['provider', 'notification-settings'] as const,
  detail: () => [...providerNotificationSettingsKeys.all, 'detail'] as const,
};

export function useProviderNotificationSettings(enabled = true) {
  return useQuery<ProviderNotificationSettings, ProviderNotificationSettingsRequestError>({
    queryKey: providerNotificationSettingsKeys.detail(),
    queryFn: () => providerNotificationSettingsService.getSettings(),
    enabled,
  });
}

export function useUpdateProviderNotificationSettings() {
  const queryClient = useQueryClient();

  return useMutation<
    ProviderNotificationSettings,
    ProviderNotificationSettingsRequestError,
    UpdateProviderNotificationSettingsInput
  >({
    mutationFn: (input) => providerNotificationSettingsService.updateSettings(input),
    onSuccess: (settings) => {
      queryClient.setQueryData(providerNotificationSettingsKeys.detail(), settings);
    },
  });
}
